import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: [],
  isLoaded: false,
  isSubmitting: false,
  page: 1,
  perPage: 50,
  total: 0,
  status: '',
  currentPromotion: null,
}

const surpriseBoxSlice = createSlice({
  name: 'surpriseBox',
  initialState,
  reducers: {
    setLoading: (state) => ({
      ...state,
      isLoaded: false,
    }),
    fetchPromotionsSuccess: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      data: payload.data,
      total: payload.total,
      page: payload.page,
    }),
    fetchPromotionsFailure: (state) => ({
      ...state,
      isLoaded: true,
    }),
    saveFilters: (state, { payload }) => ({
      ...state,
      status: payload.status ?? state.status,
      page: payload.page ?? state.page,
    }),
    setSubmitting: (state, { payload }) => ({
      ...state,
      isSubmitting: payload,
    }),
    setCurrentPromotion: (state, { payload }) => ({
      ...state,
      currentPromotion: payload,
    }),
    clearData: () => initialState,
  },
})

export default surpriseBoxSlice
